/**
 * Zod schemas for text annotation extension.
 */
import { z } from "zod"

export const textConfigSchema = z.object({
  type: z.literal("text"),
  required: z.boolean().default(false),
  placeholder: z.string().optional(),
  max_length: z.number().int().min(1).optional(),
  scope: z.enum(["case", "series"]).default("case")
})

export const createTextSchema = z.object({
  project_module_id: z.string().min(1),
  series_id: z.string().nullable().optional(),
  value_text: z.string()
})

export const updateTextSchema = z.object({
  series_id: z.string().nullable().optional(),
  value_text: z.string().optional()
})
